import { fetchDatalakeFile } from '@/services/http/datalake';

const downloadFileFromDatalake = async (fileId: string) => {
  return fetchDatalakeFile({ fileId }, 'blob');
};

export default downloadFileFromDatalake;
